// src/routes/CourierManagementRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// Courier Components
import BusinessCourierManagementPage from '../pages/couriers/BusinessCourierManagementPage';
import CourierAssignmentRulesPage from '../pages/couriers/CourierAssignmentRulesPage';

const CourierManagementRoutes = () => {
  return (
    <Routes>
      {/* Business Courier Management */}
      <Route 
        path="/" 
        element={
          <PermissionRoute requiredPermission="assign_business_couriers">
            <BusinessCourierManagementPage />
          </PermissionRoute>
        } 
      />

      {/* Courier Assignment Rules */}
      <Route 
        path="/assignment-rules" 
        element={
          <PermissionRoute requiredPermission="manage_courier_assignment_rules">
            <CourierAssignmentRulesPage />
          </PermissionRoute>
        } 
      />
    </Routes>
  );
};

export default CourierManagementRoutes;